<!-- src/views/product/ProductList.vue -->
<template>
    <div class="product-list">
      <h2>网页教程</h2>
      <ul>
        <li v-for="item in articles" :key="item.id">
      <router-link class="box" :to="`/article/article-detail/${item.id}`">
        <img  v-lazy="item.header_image"  alt="">  
        <h4>  ⭐{{ item.title }}</h4>
      
      </router-link>
    </li>
      </ul>
    </div>
  </template>
  
  <script>
  import { articleList } from '@/api/article/index.js';

export default {
  name: 'ArticleList',
  data() {
    return {
      articles: [],
    };
  },
  created() {
    this.fetchArticles();
  },
  methods: {
    async fetchArticles() {
  try {
    const response = await articleList("published"); // 调用 API 获取文章数据
    console.log('获取文章数据成功:', response); // 输出返回的数据
    this.articles = response
  } catch (error) {
    console.error('获取文章数据失败:', error); // 捕获并输出 API 请求错误
  }
}
  },
  };
  </script>
  
  <style scoped>
  .product-list {
    padding: 20px;
  }
  h2{
    font-family:"黑体";
    font-size: 5vw;
    text-align: center;
    color: #e34a44;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  
  li {  
    margin: 3vw 0 ;
    margin-top: 4vw;
    background-color: #f0f0f0;
    box-shadow: 0 0 8px #a7a6a7;
  }
  ul li .box{
    display: flex;
    padding: 1vw;
    justify-content: left;
    gap: 2vw;
    align-items: flex-start; /* 垂直对齐顶部 */
  }
  ul li .box h4{
    padding-top: 2vw;
    font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;
    font-weight: 400;
    line-height: 5.8vw;
    font-size: 4.3vw;
    color: #2c3e50;
    padding-right: 1vw;
  }
  ul li img{
    width: 20vw;
    height: 20vw;
  }
  router-link {
    color: #2c3e50;
    text-decoration: none;
    font-size: 1.2rem;
  }
  
  router-link:hover {
    color: #f56c6c;
  }
  </style>